import auth from "./auth";
import common from "./common";
import graph from "./graph";
import landing from "./landing";
import projects from "./projects";
import timeSeries from "./timeSeries";
import worksite from "./worksite";

const ko = {
  auth,
  common,
  graph,
  landing,
  projects,
  timeSeries,
  worksite,
} as const;

export default ko;
